// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  MessageToNodeValueEntry,
  MessageToNodeValueEntryT,
  verifyMessageToNodeValueEntry,
} from "./message-to-node-value-entry";
import {
  MsgToNodeTemplate,
  MsgToNodeTemplateT,
  verifyMsgToNodeTemplate,
} from "./msg-to-node-template";
import {
  NodeToMsgTemplate,
  NodeToMsgTemplateT,
  verifyNodeToMsgTemplate,
} from "./node-to-msg-template";
import {
  NodeValueToMessageEntry,
  NodeValueToMessageEntryT,
  verifyNodeValueToMessageEntry,
} from "./node-value-to-message-entry";

/**
 * Bidirectional OPC UA <-> LN2 message mappings.
 *
 * The template vectors are appended at the end of the table and are NOT
 * read by the runtime: `LiftCloud` consumes them and emits only literal
 * `node_to_msg` / `msg_to_node` entries. They live in their own vectors, and
 * not as a flag on the existing entries, so a consumer that predates them
 * ignores the templates (those floors stay unmapped) instead of reading a
 * template as one wrong literal entry.
 */
export class OpcUaMappings implements flatbuffers.IUnpackableObject<OpcUaMappingsT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OpcUaMappings {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOpcUaMappings(bb: flatbuffers.ByteBuffer, obj?: OpcUaMappings): OpcUaMappings {
    return (obj || new OpcUaMappings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsOpcUaMappings(
    bb: flatbuffers.ByteBuffer,
    obj?: OpcUaMappings,
  ): OpcUaMappings {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OpcUaMappings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  nodeToMsg(index: number, obj?: NodeValueToMessageEntry): NodeValueToMessageEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeValueToMessageEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  nodeToMsgLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  msgToNode(index: number, obj?: MessageToNodeValueEntry): MessageToNodeValueEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new MessageToNodeValueEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  msgToNodeLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  nodeToMsgTemplates(index: number, obj?: NodeToMsgTemplate): NodeToMsgTemplate | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new NodeToMsgTemplate()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  nodeToMsgTemplatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  msgToNodeTemplates(index: number, obj?: MsgToNodeTemplate): MsgToNodeTemplate | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new MsgToNodeTemplate()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  msgToNodeTemplatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startOpcUaMappings(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addNodeToMsg(builder: flatbuffers.Builder, nodeToMsgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeToMsgOffset, 0);
  }

  static createNodeToMsgVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNodeToMsgVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMsgToNode(builder: flatbuffers.Builder, msgToNodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, msgToNodeOffset, 0);
  }

  static createMsgToNodeVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMsgToNodeVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addNodeToMsgTemplates(
    builder: flatbuffers.Builder,
    nodeToMsgTemplatesOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, nodeToMsgTemplatesOffset, 0);
  }

  static createNodeToMsgTemplatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNodeToMsgTemplatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMsgToNodeTemplates(
    builder: flatbuffers.Builder,
    msgToNodeTemplatesOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(3, msgToNodeTemplatesOffset, 0);
  }

  static createMsgToNodeTemplatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMsgToNodeTemplatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endOpcUaMappings(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_to_msg
    builder.requiredField(offset, 6); // msg_to_node
    return offset;
  }

  static createOpcUaMappings(
    builder: flatbuffers.Builder,
    nodeToMsgOffset: flatbuffers.Offset,
    msgToNodeOffset: flatbuffers.Offset,
    nodeToMsgTemplatesOffset: flatbuffers.Offset,
    msgToNodeTemplatesOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    OpcUaMappings.startOpcUaMappings(builder);
    OpcUaMappings.addNodeToMsg(builder, nodeToMsgOffset);
    OpcUaMappings.addMsgToNode(builder, msgToNodeOffset);
    OpcUaMappings.addNodeToMsgTemplates(builder, nodeToMsgTemplatesOffset);
    OpcUaMappings.addMsgToNodeTemplates(builder, msgToNodeTemplatesOffset);
    return OpcUaMappings.endOpcUaMappings(builder);
  }

  unpack(): OpcUaMappingsT {
    return new OpcUaMappingsT(
      this.bb!.createObjList<NodeValueToMessageEntry, NodeValueToMessageEntryT>(
        this.nodeToMsg.bind(this),
        this.nodeToMsgLength(),
      ),
      this.bb!.createObjList<MessageToNodeValueEntry, MessageToNodeValueEntryT>(
        this.msgToNode.bind(this),
        this.msgToNodeLength(),
      ),
      this.bb!.createObjList<NodeToMsgTemplate, NodeToMsgTemplateT>(
        this.nodeToMsgTemplates.bind(this),
        this.nodeToMsgTemplatesLength(),
      ),
      this.bb!.createObjList<MsgToNodeTemplate, MsgToNodeTemplateT>(
        this.msgToNodeTemplates.bind(this),
        this.msgToNodeTemplatesLength(),
      ),
    );
  }

  unpackTo(_o: OpcUaMappingsT): void {
    _o.nodeToMsg = this.bb!.createObjList<NodeValueToMessageEntry, NodeValueToMessageEntryT>(
      this.nodeToMsg.bind(this),
      this.nodeToMsgLength(),
    );
    _o.msgToNode = this.bb!.createObjList<MessageToNodeValueEntry, MessageToNodeValueEntryT>(
      this.msgToNode.bind(this),
      this.msgToNodeLength(),
    );
    _o.nodeToMsgTemplates = this.bb!.createObjList<NodeToMsgTemplate, NodeToMsgTemplateT>(
      this.nodeToMsgTemplates.bind(this),
      this.nodeToMsgTemplatesLength(),
    );
    _o.msgToNodeTemplates = this.bb!.createObjList<MsgToNodeTemplate, MsgToNodeTemplateT>(
      this.msgToNodeTemplates.bind(this),
      this.msgToNodeTemplatesLength(),
    );
  }

  unpackFields(...fields: string[]): OpcUaMappingsT {
    const t = new OpcUaMappingsT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_to_msg")) {
      t.nodeToMsg = this.bb!.createObjList<NodeValueToMessageEntry, NodeValueToMessageEntryT>(
        this.nodeToMsg.bind(this),
        this.nodeToMsgLength(),
      );
    }
    if (fieldSet.has("msg_to_node")) {
      t.msgToNode = this.bb!.createObjList<MessageToNodeValueEntry, MessageToNodeValueEntryT>(
        this.msgToNode.bind(this),
        this.msgToNodeLength(),
      );
    }
    if (fieldSet.has("node_to_msg_templates")) {
      t.nodeToMsgTemplates = this.bb!.createObjList<NodeToMsgTemplate, NodeToMsgTemplateT>(
        this.nodeToMsgTemplates.bind(this),
        this.nodeToMsgTemplatesLength(),
      );
    }
    if (fieldSet.has("msg_to_node_templates")) {
      t.msgToNodeTemplates = this.bb!.createObjList<MsgToNodeTemplate, MsgToNodeTemplateT>(
        this.msgToNodeTemplates.bind(this),
        this.msgToNodeTemplatesLength(),
      );
    }
    return t;
  }
}

export class OpcUaMappingsT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeToMsg: NodeValueToMessageEntryT[] = [],
    public msgToNode: MessageToNodeValueEntryT[] = [],
    public nodeToMsgTemplates: NodeToMsgTemplateT[] = [],
    public msgToNodeTemplates: MsgToNodeTemplateT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeToMsg === null || this.nodeToMsg === undefined) {
      throw new Error('Required field "node_to_msg" is not set');
    }
    if (this.msgToNode === null || this.msgToNode === undefined) {
      throw new Error('Required field "msg_to_node" is not set');
    }
    const nodeToMsg = OpcUaMappings.createNodeToMsgVector(
      builder,
      builder.createObjectOffsetList(this.nodeToMsg),
    );
    const msgToNode = OpcUaMappings.createMsgToNodeVector(
      builder,
      builder.createObjectOffsetList(this.msgToNode),
    );
    const nodeToMsgTemplates = OpcUaMappings.createNodeToMsgTemplatesVector(
      builder,
      builder.createObjectOffsetList(this.nodeToMsgTemplates),
    );
    const msgToNodeTemplates = OpcUaMappings.createMsgToNodeTemplatesVector(
      builder,
      builder.createObjectOffsetList(this.msgToNodeTemplates),
    );

    return OpcUaMappings.createOpcUaMappings(
      builder,
      nodeToMsg,
      msgToNode,
      nodeToMsgTemplates,
      msgToNodeTemplates,
    );
  }

  clone(): OpcUaMappingsT {
    const obj = new OpcUaMappingsT();
    obj.nodeToMsg = this.nodeToMsg.map((e) => e.clone());
    obj.msgToNode = this.msgToNode.map((e) => e.clone());
    obj.nodeToMsgTemplates = this.nodeToMsgTemplates.map((e) => e.clone());
    obj.msgToNodeTemplates = this.msgToNodeTemplates.map((e) => e.clone());
    return obj;
  }

  equals(other: OpcUaMappingsT): boolean {
    if (this.nodeToMsg.length !== other.nodeToMsg.length) return false;
    for (let i = 0; i < this.nodeToMsg.length; i++) {
      const a = this.nodeToMsg[i];
      const b = other.nodeToMsg[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.msgToNode.length !== other.msgToNode.length) return false;
    for (let i = 0; i < this.msgToNode.length; i++) {
      const a = this.msgToNode[i];
      const b = other.msgToNode[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.nodeToMsgTemplates.length !== other.nodeToMsgTemplates.length) return false;
    for (let i = 0; i < this.nodeToMsgTemplates.length; i++) {
      const a = this.nodeToMsgTemplates[i];
      const b = other.nodeToMsgTemplates[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.msgToNodeTemplates.length !== other.msgToNodeTemplates.length) return false;
    for (let i = 0; i < this.msgToNodeTemplates.length; i++) {
      const a = this.msgToNodeTemplates[i];
      const b = other.msgToNodeTemplates[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyOpcUaMappings(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNodeValueToMessageEntry);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_to_msg");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMessageToNodeValueEntry);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "msg_to_node");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNodeToMsgTemplate);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMsgToNodeTemplate);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
